module.exports = __webpack_public_path__ + "img/calculator-card-pictures-2.0a8b879c.jpg";